module.exports = __webpack_public_path__ + "4f519a65f14eb092a248bd39a33aaecc.png";